import { useLang } from "@/LangContext";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <section className="py-10 border-y border-border overflow-hidden bg-card" data-testid="marquee">
      <div className="flex whitespace-nowrap marquee-track">
        {items.map((item, i) => (
          <span key={i} className="flex items-center font-serif text-4xl md:text-5xl text-foreground/40 mx-8">
            {item}
            <span className="text-accent mx-8 text-3xl">✳</span>
          </span>
        ))}
      </div>
    </section>
  );
}
